import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { removeAddDevice, changeProgress } from '../../redux/actions/selfserveActions';
import { useDispatch, connect } from 'react-redux'
import { useRouter } from 'next/router';
import { addAppRenderParams } from '../../utils/selfserve';
interface ReduxStateProps {
    selfserveReducer: any,
}
interface MainProps {
    is_open: boolean,
    setEnableModal: any,
    deviceKey: any,
}
type Props = ReduxStateProps & MainProps;


const ConfirmDeleteDeviceModel = (props: Props) => {
    const { ticket_list } = props.selfserveReducer
    const dispatch:any = useDispatch();
    const router = useRouter()
    const close = () => {
        props.setEnableModal(false);
    }
    const proceed = (deviceKey) => {
        dispatch(removeAddDevice(deviceKey));
        if(Object.keys(ticket_list).length === 0){
            if(router?.query?.app_render){
                addAppRenderParams(router)
            }
            router.push("/account/plans")
        }else{
            close();
        }
    }
    const title = "Attention!"
    const text = Object.keys(ticket_list).length !== 1
        ? "Are you sure you want to remove this device?"
        : "Are you sure you want to remove this device? You will be redirected the plan page ?"

    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            <div className={styles.selfserve_add_device}>
                <h5 className={styles.selfserve_add_device__title}>{title}</h5>
                <div className={styles.selfserve_add_device__text}>
                    <p>{text}</p>
                </div>
                <div className={`${commonStyles.button_actions_sticky} ${styles.add_device_buttons}`} data-varient='non-sticky'>
                    <Button
                        onClick={close}
                        text="Cancel"
                        variant="secondary"
                        className={commonStyles.cart_btn}
                        style={{ 'fontSize': '14px' }}
                    />
                    <Button
                        text="Delete"
                        onClick={()=>proceed(props.deviceKey)}
                        className={commonStyles.cart_btn}
                        style={{ 'fontSize': '14px' }}
                    />
                </div>
            </div>
        </UIModal>
    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(ConfirmDeleteDeviceModel);
